// src/LanguageSwitcherList/LanguageSwitcherListItem/LanguageSwitcherListItem.tsx
import { Flex, ListItem, Box } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var LanguageSwitcherListItem = ({ item, onItemClick, isActive }) => /* @__PURE__ */ jsx(ListItem, {
  color: isActive ? "primary.900" : "greyscale.600",
  _hover: {
    md: {
      textDecoration: "none",
      backgroundColor: "greyscale.200",
      color: "primary.900"
    }
  },
  onClick: () => onItemClick(item),
  cursor: "pointer",
  bg: isActive ? "greyscale.300" : "initial",
  borderRadius: "md",
  p: 3,
  my: "px",
  transition: ".3s",
  "data-testid": isActive && "languageSwitcherListItemActive",
  children: /* @__PURE__ */ jsxs(Flex, {
    align: "center",
    "data-testid": item.id,
    children: [
      item.icon && /* @__PURE__ */ jsx(item.icon, {
        w: 6,
        h: 4
      }),
      /* @__PURE__ */ jsx(Box, {
        ml: 3,
        fontSize: "md",
        fontWeight: "normal",
        children: item.name
      })
    ]
  })
});

export {
  LanguageSwitcherListItem
};
